module.exports = __webpack_public_path__ + "img/pmap.e3f50ac6.jpg";